
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gym",
      function () {
        return require("private-next-pages/gym.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gym"])
      });
    }
  